var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Tag',_vm._b({},"Tag",_vm._d({},[_vm.tagType,true])),[_vm._v(" "+_vm._s(_vm.transaction.status.formatted)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }